export default __webpack_public_path__ + "static/media/8.1d5ce657.png";